'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import BookWithContainer from '@/components/BookWithContainer';
import { useExternalLinkTracking } from '@/hooks/useExternalLinkTracking';
interface BookData {
  slug: string;
  title: string;
  author: string;
  cover?: string;
}
interface BookCurrentlyProps {
  data: BookData;
}
const BOOK_SIZE = 280;
export default function BookCurrently(t0) {
  const $ = _c(12);
  const {
    data
  } = t0;
  const trackExternalLink = useExternalLinkTracking();
  let t1;
  if ($[0] !== data.slug || $[1] !== trackExternalLink) {
    t1 = () => trackExternalLink(`https://literal.club/book/${data.slug}`, "currently_literal");
    $[0] = data.slug;
    $[1] = trackExternalLink;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trackBookOpen = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-xs font-medium text-zinc-500 dark:text-zinc-400">Reading</p>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `https://literal.club/book/${data.slug}`;
  let t4;
  if ($[4] !== data.author || $[5] !== data.cover || $[6] !== data.title) {
    t4 = <BookWithContainer inline={true} size={BOOK_SIZE} title={data.title} author={data.author} coverImage={data.cover} />;
    $[4] = data.author;
    $[5] = data.cover;
    $[6] = data.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== trackBookOpen) {
    t5 = <div className="flex flex-col items-start gap-2">{t2}<Link href={t3} target="_blank" rel="noopener noreferrer" onClick={trackBookOpen}>{t4}</Link></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = trackBookOpen;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}